"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListBrandsAvailCtl_1 = require("./shared/controllers/ListBrandsAvailCtl");
var ListAdminsAvailCtl_1 = require("./shared/controllers/ListAdminsAvailCtl");
var ListGwsGameProvidersAvailCtl_1 = require("./shared/controllers/ListGwsGameProvidersAvailCtl");
var ListAffilatesAvailCtl_1 = require("./shared/controllers/ListAffilatesAvailCtl");
var ListAppCurrencyAvailCtl_1 = require("./shared/controllers/ListAppCurrencyAvailCtl");
var ListBonusEventTypesAvailCtl_1 = require("./shared/controllers/ListBonusEventTypesAvailCtl");
var ListBonusTemplateTypesAvailCtl_1 = require("./shared/controllers/ListBonusTemplateTypesAvailCtl");
var ListBonusTemplatesAvailForEventHandlersCtl_1 = require("./shared/controllers/ListBonusTemplatesAvailForEventHandlersCtl");
var ListPlayerLevelsByBrandIdAvailCtl_1 = require("./shared/controllers/ListPlayerLevelsByBrandIdAvailCtl");
var ListBonusTemplatesAvailForPromoCodesCtl_1 = require("./shared/controllers/ListBonusTemplatesAvailForPromoCodesCtl");
var ListAppCountryAvailCtl_1 = require("./shared/controllers/ListAppCountryAvailCtl");
var ListAppLanguageAvailCtl_1 = require("./shared/controllers/ListAppLanguageAvailCtl");
var coreDialog_1 = require("./coreDialog");
var ListAppUserPlayerTagTypesAvailCtl_1 = require("./shared/controllers/ListAppUserPlayerTagTypesAvailCtl");
var ListAppUserPlayerTagsAvailCtl_1 = require("./shared/controllers/ListAppUserPlayerTagsAvailCtl");
var ListAdminsPermissionsAvailCtl_1 = require("./shared/controllers/ListAdminsPermissionsAvailCtl");
var ListGwsGameProviderGamesAvailCtl_1 = require("./shared/controllers/ListGwsGameProviderGamesAvailCtl");
var ListCmsGameSetsAvailCtl_1 = require("./shared/controllers/ListCmsGameSetsAvailCtl");
var ListPromoCodeTemplatesForLevelsAvailCtl_1 = require("./shared/controllers/ListPromoCodeTemplatesForLevelsAvailCtl");
var ListPromoCodeTemplateCodesAllowedByTemplateIdCtl_1 = require("./shared/controllers/ListPromoCodeTemplateCodesAllowedByTemplateIdCtl");
var ListUsrPlayersBotsCtl_1 = require("./shared/controllers/ListUsrPlayersBotsCtl");
var ListAppCssClassesAvailCtl_1 = require("./shared/controllers/ListAppCssClassesAvailCtl");
var ListAppCssClassesTypesAvailCtl_1 = require("./shared/controllers/ListAppCssClassesTypesAvailCtl");
var ListTopGameTypesAvailCtl_1 = require("./shared/controllers/ListTopGameTypesAvailCtl");
var ListAuthStateTypesAvailCtl_1 = require("./shared/controllers/ListAuthStateTypesAvailCtl");
var ListTopWinnersDatesAvailCtl_1 = require("./shared/controllers/ListTopWinnersDatesAvailCtl");
var ListPromoCodeTemplateTypesAvailCtl_1 = require("./shared/controllers/ListPromoCodeTemplateTypesAvailCtl");
var ListBannersGeometryAvailCtl_1 = require("./shared/controllers/ListBannersGeometryAvailCtl");
var ListBannersFormatAvailCtl_1 = require("./shared/controllers/ListBannersFormatAvailCtl");
var ListAffilateOfferTypesAvailCtl_1 = require("./shared/controllers/ListAffilateOfferTypesAvailCtl");
var ListAffilateOffersAvailCtl_1 = require("./shared/controllers/ListAffilateOffersAvailCtl");
var ListAffilatesPartnersAvailCtl_1 = require("./shared/controllers/ListAffilatesPartnersAvailCtl");
var ListAffilatesPartnersOffersAvailCtl_1 = require("./shared/controllers/ListAffilatesPartnersOffersAvailCtl");
var ListAffilatesPartnersTrackersAvailCtl_1 = require("./shared/controllers/ListAffilatesPartnersTrackersAvailCtl");
var ListEmailActionsAvailCtl_1 = require("./shared/controllers/ListEmailActionsAvailCtl");
var ListBonusTemplatesAvailForDepositTypeCtl_1 = require("./shared/controllers/ListBonusTemplatesAvailForDepositTypeCtl");
var ListBonusTemplatesAvailForPlayers_1 = require("./shared/controllers/ListBonusTemplatesAvailForPlayers");
var ListBonusCancelTypesAvailCtl_1 = require("./shared/controllers/ListBonusCancelTypesAvailCtl");
var ListBonusDebitTypesAvailCtl_1 = require("./shared/controllers/ListBonusDebitTypesAvailCtl");
var ListBonusPermissionTypesAvailCtl_1 = require("./shared/controllers/ListBonusPermissionTypesAvailCtl");
var ListBonusJackpotTransferTypesAvailCtl_1 = require("./shared/controllers/ListBonusJackpotTransferTypesAvailCtl");
var ListBonusJackpotsAvailCtl_1 = require("./shared/controllers/ListBonusJackpotsAvailCtl");
var EventBindingBonusesListCtl_1 = require("./components/pages/gift_events_bindings/ctl/EventBindingBonusesListCtl");
var ListBonusWithdrawalBehaviorTypesAvailCtl_1 = require("./shared/controllers/ListBonusWithdrawalBehaviorTypesAvailCtl");
var ListBonusActivationTypesAvailCtl_1 = require("./shared/controllers/ListBonusActivationTypesAvailCtl");
var ListCmsGameSetGamesAvailCtl_1 = require("./shared/controllers/ListCmsGameSetGamesAvailCtl");
var ListBonusLevelsAvailCtl_1 = require("./shared/controllers/ListBonusLevelsAvailCtl");
var ListAppPayoutAvailCtl_1 = require("./shared/controllers/ListAppPayoutAvailCtl");
var ListAffilatesPayoutsAvailCtl_1 = require("./shared/controllers/ListAffilatesPayoutsAvailCtl");
var ListAffilatesBrandsAvailCtl_1 = require("./shared/controllers/ListAffilatesBrandsAvailCtl");
var ListPromoCodeTemplatesForBrandsAvailCtl_1 = require("./shared/controllers/ListPromoCodeTemplatesForBrandsAvailCtl");
var ListPartnersBrandsAvailCtl_1 = require("./shared/controllers/ListPartnersBrandsAvailCtl");
var ListPartnerOffersAvailCtl_1 = require("./shared/controllers/ListPartnerOffersAvailCtl");
var ListPProgramsAvailCtl_1 = require("./shared/controllers/ListPProgramsAvailCtl");
var ListPProgramsPartnersAvailCtl_1 = require("./shared/controllers/ListPProgramsPartnersAvailCtl");
var ListBonusLevelSourceTypesAvailCtl_1 = require("./shared/controllers/ListBonusLevelSourceTypesAvailCtl");
var ListForBrandStatPartnerOffersAvailCtl_1 = require("./shared/controllers/ListForBrandStatPartnerOffersAvailCtl");
var ListForBrandStatPartnersAvailCtl_1 = require("./shared/controllers/ListForBrandStatPartnersAvailCtl");
var ListForBrandStatPProgramsAvailCtl_1 = require("./shared/controllers/ListForBrandStatPProgramsAvailCtl");
var ListPartnerOffersInheritanceTypesAvailCtl_1 = require("./shared/controllers/ListPartnerOffersInheritanceTypesAvailCtl");
var ListFSRangesAvailCtl_1 = require("./shared/controllers/ListFSRangesAvailCtl");
var ListPromoCodeTemplateReActivationTypesAvailCtl_1 = require("./shared/controllers/ListPromoCodeTemplateReActivationTypesAvailCtl");
var ListPromoCodeTemplateDepositAgeTypesAvailCtl_1 = require("./shared/controllers/ListPromoCodeTemplateDepositAgeTypesAvailCtl");
var ListUsrPlayersAvailCtl_1 = require("./shared/controllers/ListUsrPlayersAvailCtl");
var ListBonusTournamentsPrizeTypesAvailCtl_1 = require("./shared/controllers/ListBonusTournamentsPrizeTypesAvailCtl");
var ListBonusTemplateTypesAvailForTournamentCtl_1 = require("./shared/controllers/ListBonusTemplateTypesAvailForTournamentCtl");
var ListBonusTournamentsJoinTypesAvailCtl_1 = require("./shared/controllers/ListBonusTournamentsJoinTypesAvailCtl");
var ListCmsGameSetGamesBotWinTypesAvailCtl_1 = require("./shared/controllers/ListCmsGameSetGamesBotWinTypesAvailCtl");
var ListBonusTournamentsGamesAvailCtl_1 = require("./shared/controllers/ListBonusTournamentsGamesAvailCtl");
var ListGwsGameProviderZonesAvailCtl_1 = require("./shared/controllers/ListGwsGameProviderZonesAvailCtl");
var BonusTournamentsGameLogsListCtl_1 = require("./components/pages/gift_tournament/ctl/options/BonusTournamentsGameLogsListCtl");
var BonusTournamentActionLogsListCtl_1 = require("./components/pages/gift_tournament/ctl/options/BonusTournamentActionLogsListCtl");
var ListFlowTypesWithdrawsAvailCtl_1 = require("./shared/controllers/ListFlowTypesWithdrawsAvailCtl");
var ListFlowTypesDepositsAvailCtk_1 = require("./shared/controllers/ListFlowTypesDepositsAvailCtk");
var ListBonusStateTypesAvailCtl_1 = require("./shared/controllers/ListBonusStateTypesAvailCtl");
var ListCmsGameSetTypesAvailCtl_1 = require("./shared/controllers/ListCmsGameSetTypesAvailCtl");
var ListGwsGameProviderCategoriesAvailCtl_1 = require("./shared/controllers/ListGwsGameProviderCategoriesAvailCtl");
var ListSmsActionsAvailCtl_1 = require("./shared/controllers/ListSmsActionsAvailCtl");
var ListFireWallRulesActionsAvailCtl_1 = require("./shared/controllers/ListFireWallRulesActionsAvailCtl");
var ListBrandSmsProvidersAvailCtl_1 = require("./shared/controllers/ListBrandSmsProvidersAvailCtl");
var ListUsrPlayersBehavourTypesAvailCtl_1 = require("./shared/controllers/ListUsrPlayersBehavourTypesAvailCtl");
var ListTresholdBehaviorTypesAvailCtl_1 = require("./shared/controllers/ListTresholdBehaviorTypesAvailCtl");
var ListBrandGwsGameZonesBehaviorTypesAvailCtl_1 = require("./shared/controllers/ListBrandGwsGameZonesBehaviorTypesAvailCtl");
var ListDomainTypesAvailCtl_1 = require("./shared/controllers/ListDomainTypesAvailCtl");
var ListPProgramRevsharesMoneyFlowTypesAvailCtl_1 = require("./shared/controllers/ListPProgramRevsharesMoneyFlowTypesAvailCtl");
var ListBonusTournamentsKindsAvailCtl_1 = require("./shared/controllers/ListBonusTournamentsKindsAvailCtl");
var ListBrandAppPayoutTypesAvailCtl_1 = require("./shared/controllers/ListBrandAppPayoutTypesAvailCtl");
var ListTrustZonesAvailCtl_1 = require("./shared/controllers/ListTrustZonesAvailCtl");
var ListTrustEventHandlerTypesAvailCtl_1 = require("./shared/controllers/ListTrustEventHandlerTypesAvailCtl");
var ListMessageActionsAvailCtl_1 = require("./shared/controllers/ListMessageActionsAvailCtl");
var ListPermissionDocumentCodesAvailCtl_1 = require("./shared/controllers/ListPermissionDocumentCodesAvailCtl");
var ListAppInnerCryptoCurrencyTypesAvailCtl_1 = require("./shared/controllers/ListAppInnerCryptoCurrencyTypesAvailCtl");
var ListAppPayServicesAvailGtl_1 = require("./shared/controllers/ListAppPayServicesAvailGtl");
var ListBrandPlayerRegistrationTypesBehaviorAvailCtl_1 = require("./shared/controllers/ListBrandPlayerRegistrationTypesBehaviorAvailCtl");
var ListBrandSecurityParsingActionsAvailCtl_1 = require("./shared/controllers/ListBrandSecurityParsingActionsAvailCtl");
var ListAppTrustZonesAvailCtl_1 = require("./shared/controllers/ListAppTrustZonesAvailCtl");
var ListBrandPayProvidersAvailCtl_1 = require("./shared/controllers/ListBrandPayProvidersAvailCtl");
var ListAppRestrictionMessageTypesAvailCtl_1 = require("./shared/controllers/ListAppRestrictionMessageTypesAvailCtl");
var ListFireWallEventsAvailCtl_1 = require("./shared/controllers/ListFireWallEventsAvailCtl");
var ListFireWallRestrictionMessageTypesAvailCtl_1 = require("./shared/controllers/ListFireWallRestrictionMessageTypesAvailCtl");
var ListPersonalPromoCodeHandlingTypesAvailCtl_1 = require("./shared/controllers/ListPersonalPromoCodeHandlingTypesAvailCtl");
var ListPersonalPromoCodeOffersAvailGetCtl_1 = require("./shared/controllers/ListPersonalPromoCodeOffersAvailGetCtl");
var LIST = /** @class */ (function () {
    function LIST() {
    }
    Object.defineProperty(LIST, "ListPersonalPromoCodeOffersAvail", {
        get: function () {
            if (!this._ListPersonalPromoCodeOffersAvail) {
                this._ListPersonalPromoCodeOffersAvail = new ListPersonalPromoCodeOffersAvailGetCtl_1.ListPersonalPromoCodeOffersAvailGetCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPersonalPromoCodeOffersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPersonalPromoCodeHandlingTypesAvail", {
        get: function () {
            if (!this._ListPersonalPromoCodeHandlingTypesAvail) {
                this._ListPersonalPromoCodeHandlingTypesAvail = new ListPersonalPromoCodeHandlingTypesAvailCtl_1.ListPersonalPromoCodeHandlingTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPersonalPromoCodeHandlingTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListFireWallRestrictionMessageTypesAvail", {
        get: function () {
            if (!this._ListFireWallRestrictionMessageTypesAvail) {
                this._ListFireWallRestrictionMessageTypesAvail = new ListFireWallRestrictionMessageTypesAvailCtl_1.ListFireWallRestrictionMessageTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListFireWallRestrictionMessageTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListFireWallEventsAvail", {
        get: function () {
            if (!this._ListFireWallEventsAvail) {
                this._ListFireWallEventsAvail = new ListFireWallEventsAvailCtl_1.ListFireWallEventsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListFireWallEventsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppRestrictionMessageTypesAvail", {
        get: function () {
            if (!this._ListAppRestrictionMessageTypesAvail) {
                this._ListAppRestrictionMessageTypesAvail = new ListAppRestrictionMessageTypesAvailCtl_1.ListAppRestrictionMessageTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppRestrictionMessageTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBrandPayProvidersAvail", {
        get: function () {
            if (!this._ListBrandPayProvidersAvail) {
                this._ListBrandPayProvidersAvail = new ListBrandPayProvidersAvailCtl_1.ListBrandPayProvidersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBrandPayProvidersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppTrustZonesAvail", {
        get: function () {
            if (!this._ListAppTrustZonesAvail) {
                this._ListAppTrustZonesAvail = new ListAppTrustZonesAvailCtl_1.ListAppTrustZonesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppTrustZonesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBrandSecurityParsingActionsAvail", {
        get: function () {
            if (!this._ListBrandSecurityParsingActionsAvail) {
                this._ListBrandSecurityParsingActionsAvail = new ListBrandSecurityParsingActionsAvailCtl_1.ListBrandSecurityParsingActionsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBrandSecurityParsingActionsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBrandPlayerRegistrationTypesBehaviorAvail", {
        get: function () {
            if (!this._ListBrandPlayerRegistrationTypesBehaviorAvail) {
                this._ListBrandPlayerRegistrationTypesBehaviorAvail = new ListBrandPlayerRegistrationTypesBehaviorAvailCtl_1.ListBrandPlayerRegistrationTypesBehaviorAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBrandPlayerRegistrationTypesBehaviorAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppPayServicesAvail", {
        get: function () {
            if (!this._ListAppPayServicesAvail) {
                this._ListAppPayServicesAvail = new ListAppPayServicesAvailGtl_1.ListAppPayServicesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppPayServicesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppInnerCryptoCurrencyTypesAvail", {
        get: function () {
            if (!this._ListAppInnerCryptoCurrencyTypesAvail) {
                this._ListAppInnerCryptoCurrencyTypesAvail = new ListAppInnerCryptoCurrencyTypesAvailCtl_1.ListAppInnerCryptoCurrencyTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppInnerCryptoCurrencyTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPermissionDocumentCodesAvail", {
        get: function () {
            if (!this._ListPermissionDocumentCodesAvail) {
                this._ListPermissionDocumentCodesAvail = new ListPermissionDocumentCodesAvailCtl_1.ListPermissionDocumentCodesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPermissionDocumentCodesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListMessageActionsAvail", {
        get: function () {
            if (!this._ListMessageActionsAvail) {
                this._ListMessageActionsAvail = new ListMessageActionsAvailCtl_1.ListMessageActionsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListMessageActionsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListTrustEventHandlerTypesAvail", {
        get: function () {
            if (!this._ListTrustEventHandlerTypesAvail) {
                this._ListTrustEventHandlerTypesAvail = new ListTrustEventHandlerTypesAvailCtl_1.ListTrustEventHandlerTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListTrustEventHandlerTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListTrustZonesAvail", {
        get: function () {
            if (!this._ListTrustZonesAvail) {
                this._ListTrustZonesAvail = new ListTrustZonesAvailCtl_1.ListTrustZonesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListTrustZonesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBrandAppPayoutTypesAvail", {
        get: function () {
            if (!this._ListBrandAppPayoutTypesAvail) {
                this._ListBrandAppPayoutTypesAvail = new ListBrandAppPayoutTypesAvailCtl_1.ListBrandAppPayoutTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBrandAppPayoutTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusTournamentsKindsAvail", {
        get: function () {
            if (!this._ListBonusTournamentsKindsAvail) {
                this._ListBonusTournamentsKindsAvail = new ListBonusTournamentsKindsAvailCtl_1.ListBonusTournamentsKindsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusTournamentsKindsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPProgramRevsharesMoneyFlowTypesAvail", {
        get: function () {
            if (!this._ListPProgramRevsharesMoneyFlowTypesAvail) {
                this._ListPProgramRevsharesMoneyFlowTypesAvail = new ListPProgramRevsharesMoneyFlowTypesAvailCtl_1.ListPProgramRevsharesMoneyFlowTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPProgramRevsharesMoneyFlowTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListDomainTypesAvail", {
        get: function () {
            if (!this._ListDomainTypesAvail) {
                this._ListDomainTypesAvail = new ListDomainTypesAvailCtl_1.ListDomainTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListDomainTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBrandGwsGameZonesBehaviorTypesAvail", {
        get: function () {
            if (!this._ListBrandGwsGameZonesBehaviorTypesAvail) {
                this._ListBrandGwsGameZonesBehaviorTypesAvail = new ListBrandGwsGameZonesBehaviorTypesAvailCtl_1.ListBrandGwsGameZonesBehaviorTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBrandGwsGameZonesBehaviorTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListTresholdBehaviorTypesAvail", {
        get: function () {
            if (!this._ListTresholdBehaviorTypesAvail) {
                this._ListTresholdBehaviorTypesAvail = new ListTresholdBehaviorTypesAvailCtl_1.ListTresholdBehaviorTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListTresholdBehaviorTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPlayerBehaviorTypesAvail", {
        get: function () {
            if (!this._ListPlayerBehaviorTypesAvail) {
                this._ListPlayerBehaviorTypesAvail = new ListUsrPlayersBehavourTypesAvailCtl_1.ListPlayerBehaviorTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPlayerBehaviorTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBrandSmsProvidersAvail", {
        get: function () {
            if (!this._ListBrandSmsProvidersAvail) {
                this._ListBrandSmsProvidersAvail = new ListBrandSmsProvidersAvailCtl_1.ListBrandSmsProvidersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBrandSmsProvidersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListFireWallRulesActionsAvail", {
        get: function () {
            if (!this._ListFireWallRulesActionsAvail) {
                this._ListFireWallRulesActionsAvail = new ListFireWallRulesActionsAvailCtl_1.ListFireWallRulesActionsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListFireWallRulesActionsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListGwsGameProviderCategoriesAvail", {
        get: function () {
            if (!this._ListGwsGameProviderCategoriesAvail) {
                this._ListGwsGameProviderCategoriesAvail = new ListGwsGameProviderCategoriesAvailCtl_1.ListGwsGameProviderCategoriesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListGwsGameProviderCategoriesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListCmsGameSetTypesAvail", {
        get: function () {
            if (!this._ListCmsGameSetTypesAvail) {
                this._ListCmsGameSetTypesAvail = new ListCmsGameSetTypesAvailCtl_1.ListCmsGameSetTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListCmsGameSetTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusStateTypesAvail", {
        get: function () {
            if (!this._ListBonusStateTypesAvail) {
                this._ListBonusStateTypesAvail = new ListBonusStateTypesAvailCtl_1.ListBonusStateTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusStateTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListFlowTypesDepositsAvail", {
        get: function () {
            if (!this._ListFlowTypesDepositsAvailCtl) {
                this._ListFlowTypesDepositsAvailCtl = new ListFlowTypesDepositsAvailCtk_1.ListFlowTypesDepositsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListFlowTypesDepositsAvailCtl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListFlowTypesWithdrawsAvail", {
        get: function () {
            if (!this._ListFlowTypesWithdrawsAvail) {
                this._ListFlowTypesWithdrawsAvail = new ListFlowTypesWithdrawsAvailCtl_1.ListFlowTypesWithdrawsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListFlowTypesWithdrawsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListGwsGameProviderZonesAvail", {
        get: function () {
            if (!this._ListGwsGameProviderZonesAvailCtl) {
                this._ListGwsGameProviderZonesAvailCtl = new ListGwsGameProviderZonesAvailCtl_1.ListGwsGameProviderZonesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListGwsGameProviderZonesAvailCtl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "BonusTournamentsActionLogsList", {
        get: function () {
            if (!this._BonusTournamentsActionLogsListCtl) {
                this._BonusTournamentsActionLogsListCtl = new BonusTournamentActionLogsListCtl_1.BonusTournamentsActionLogsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentsActionLogsListCtl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "BonusTournamentsGameLogsList", {
        get: function () {
            if (!this._BonusTournamentsGameLogsListCtl) {
                this._BonusTournamentsGameLogsListCtl = new BonusTournamentsGameLogsListCtl_1.BonusTournamentsGameLogsListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._BonusTournamentsGameLogsListCtl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusTournamentsGamesAvail", {
        get: function () {
            if (!this._ListBonusTournamentsGamesAvailCtl) {
                this._ListBonusTournamentsGamesAvailCtl = new ListBonusTournamentsGamesAvailCtl_1.ListBonusTournamentsGamesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusTournamentsGamesAvailCtl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListCmsGameSetGamesBotWinTypesAvail", {
        get: function () {
            if (!this._ListCmsGameSetGamesBotWinTypesAvail) {
                this._ListCmsGameSetGamesBotWinTypesAvail = new ListCmsGameSetGamesBotWinTypesAvailCtl_1.ListCmsGameSetGamesBotWinTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListCmsGameSetGamesBotWinTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusTournamentJoinTypesAvail", {
        get: function () {
            if (!this._ListBonusTournamentJoinTypesAvail) {
                this._ListBonusTournamentJoinTypesAvail = new ListBonusTournamentsJoinTypesAvailCtl_1.ListBonusTournamentJoinTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusTournamentJoinTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusTemplateTypesAvailForTournament", {
        get: function () {
            if (!this._ListBonusTemplateTypesAvailForTournament) {
                this._ListBonusTemplateTypesAvailForTournament = new ListBonusTemplateTypesAvailForTournamentCtl_1.ListBonusTemplateTypesAvailForTournamentCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusTemplateTypesAvailForTournament;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusTournamentPrizeTypesAvail", {
        get: function () {
            if (!this._ListBonusTournamentPrizeTypesAvail) {
                this._ListBonusTournamentPrizeTypesAvail = new ListBonusTournamentsPrizeTypesAvailCtl_1.ListBonusTournamentPrizeTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusTournamentPrizeTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListUsrPlayersAvail", {
        get: function () {
            if (!this._ListUsrPlayersAvail) {
                this._ListUsrPlayersAvail = new ListUsrPlayersAvailCtl_1.ListUsrPlayersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListUsrPlayersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPromoCodeTemplateDepositAgeTypesAvail", {
        get: function () {
            if (!this._ListPromoCodeTemplateDepositAgeTypesAvail) {
                this._ListPromoCodeTemplateDepositAgeTypesAvail = new ListPromoCodeTemplateDepositAgeTypesAvailCtl_1.ListPromoCodeTemplateDepositAgeTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPromoCodeTemplateDepositAgeTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPromoCodeTemplateReActivationTypesAvail", {
        get: function () {
            if (!this._ListPromoCodeTemplateReActivationTypesAvail) {
                this._ListPromoCodeTemplateReActivationTypesAvail = new ListPromoCodeTemplateReActivationTypesAvailCtl_1.ListPromoCodeTemplateReActivationTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPromoCodeTemplateReActivationTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListFSRangesAvail", {
        get: function () {
            if (!this._ListFSRangesAvail) {
                this._ListFSRangesAvail = new ListFSRangesAvailCtl_1.ListFSRangesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListFSRangesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPartnersOffersInheritanceTypesAvail", {
        get: function () {
            if (!this._ListPartnersOffersInheritanceTypesAvail) {
                this._ListPartnersOffersInheritanceTypesAvail = new ListPartnerOffersInheritanceTypesAvailCtl_1.ListPartnersOffersInheritanceTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPartnersOffersInheritanceTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListForBrandStatPartnerOffersAvail", {
        get: function () {
            if (!this._ListForBrandStatPartnerOffersAvail) {
                this._ListForBrandStatPartnerOffersAvail = new ListForBrandStatPartnerOffersAvailCtl_1.ListForBrandStatPartnerOffersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListForBrandStatPartnerOffersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListForBrandStatPProgramsAvail", {
        get: function () {
            if (!this._ListForBrandStatPProgramsAvail) {
                this._ListForBrandStatPProgramsAvail = new ListForBrandStatPProgramsAvailCtl_1.ListForBrandStatPProgramsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListForBrandStatPProgramsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListForBrandStatPartnersAvail", {
        get: function () {
            if (!this._ListForBrandStatPartnersAvail) {
                this._ListForBrandStatPartnersAvail = new ListForBrandStatPartnersAvailCtl_1.ListForBrandStatPartnersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListForBrandStatPartnersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusLevelSourceTypesAvail", {
        get: function () {
            if (!this._ListBonusLevelSourceTypesAvail) {
                this._ListBonusLevelSourceTypesAvail = new ListBonusLevelSourceTypesAvailCtl_1.ListBonusLevelSourceTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusLevelSourceTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPProgramPartnersAvail", {
        get: function () {
            if (!this._ListPProgramPartnersAvail) {
                this._ListPProgramPartnersAvail = new ListPProgramsPartnersAvailCtl_1.ListPProgramPartnersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPProgramPartnersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPProgramsAvail", {
        get: function () {
            if (!this._ListPProgramsAvail) {
                this._ListPProgramsAvail = new ListPProgramsAvailCtl_1.ListPProgramsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPProgramsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAffilatesPartnersAvail", {
        get: function () {
            if (!this._ListAffilatesPartnersAvail) {
                this._ListAffilatesPartnersAvail = new ListAffilatesPartnersAvailCtl_1.ListAffilatesPartnersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAffilatesPartnersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAffilatesPartnersOffersAvail", {
        get: function () {
            if (!this._ListAffilatesPartnersOffersAvail) {
                this._ListAffilatesPartnersOffersAvail = new ListAffilatesPartnersOffersAvailCtl_1.ListAffilatesPartnersOffersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAffilatesPartnersOffersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAffilatesPartnersTrackersAvail", {
        get: function () {
            if (!this._ListAffilatesPartnersTrackersAvail) {
                this._ListAffilatesPartnersTrackersAvail = new ListAffilatesPartnersTrackersAvailCtl_1.ListAffilatesPartnersTrackersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAffilatesPartnersTrackersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAffilatesPayoutsAvail", {
        get: function () {
            if (!this._ListAffilatesPayoutsAvail) {
                this._ListAffilatesPayoutsAvail = new ListAffilatesPayoutsAvailCtl_1.ListAffilatesPayoutsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAffilatesPayoutsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAffilatesBrandsAvail", {
        get: function () {
            if (!this._ListAffilatesBrandsAvail) {
                this._ListAffilatesBrandsAvail = new ListAffilatesBrandsAvailCtl_1.ListAffilatesBrandsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAffilatesBrandsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPartnersOffersAvail", {
        get: function () {
            if (!this._ListPartnersOffersAvail) {
                this._ListPartnersOffersAvail = new ListPartnerOffersAvailCtl_1.ListPartnersOffersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPartnersOffersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPartnersBrandsAvail", {
        get: function () {
            if (!this._ListPartnersBrandsAvail) {
                this._ListPartnersBrandsAvail = new ListPartnersBrandsAvailCtl_1.ListPartnersBrandsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPartnersBrandsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAffilateOffersAvail", {
        get: function () {
            if (!this._ListAffilateOffersAvail) {
                this._ListAffilateOffersAvail = new ListAffilateOffersAvailCtl_1.ListAffilateOffersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAffilateOffersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAffilateOfferTypesAvail", {
        get: function () {
            if (!this._ListAffilateOfferTypesAvail) {
                this._ListAffilateOfferTypesAvail = new ListAffilateOfferTypesAvailCtl_1.ListAffilateOfferTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAffilateOfferTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBannersFormatAvail", {
        get: function () {
            if (!this._ListBannersFormatAvail) {
                this._ListBannersFormatAvail = new ListBannersFormatAvailCtl_1.ListBannersFormatAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBannersFormatAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBannersGeometryAvail", {
        get: function () {
            if (!this._ListBannersGeometryAvail) {
                this._ListBannersGeometryAvail = new ListBannersGeometryAvailCtl_1.ListBannersGeometryAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBannersGeometryAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPromoCodeTemplateTypesAvail", {
        get: function () {
            if (!this._ListPromoCodeTemplateTypesAvail) {
                this._ListPromoCodeTemplateTypesAvail = new ListPromoCodeTemplateTypesAvailCtl_1.ListPromoCodeTemplateTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPromoCodeTemplateTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListTopWinnersDatesAvail", {
        get: function () {
            if (!this._ListTopWinnersDatesAvail) {
                this._ListTopWinnersDatesAvail = new ListTopWinnersDatesAvailCtl_1.ListTopWinnersDatesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListTopWinnersDatesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAuthStateTypesAvail", {
        get: function () {
            if (!this._ListAuthStateTypesAvail) {
                this._ListAuthStateTypesAvail = new ListAuthStateTypesAvailCtl_1.ListAuthStateTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAuthStateTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListTopGameTypesAvail", {
        get: function () {
            if (!this._ListTopGameTypesAvail) {
                this._ListTopGameTypesAvail = new ListTopGameTypesAvailCtl_1.ListTopGameTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListTopGameTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListUsrPlayersBotsAvail", {
        get: function () {
            if (!this._ListUsrPlayersBotsCtl) {
                this._ListUsrPlayersBotsCtl = new ListUsrPlayersBotsCtl_1.ListUsrPlayersBotsCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListUsrPlayersBotsCtl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPromoTypeCodesAllowedByTypeIdAvail", {
        get: function () {
            if (!this._ListPromoTypeCodesAllowedByTypeIdCtl) {
                this._ListPromoTypeCodesAllowedByTypeIdCtl = new ListPromoCodeTemplateCodesAllowedByTemplateIdCtl_1.ListPromoTypeCodesAllowedByTypeIdCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPromoTypeCodesAllowedByTypeIdCtl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPromoCodeTemplatesForBrandsAvail", {
        get: function () {
            if (!this._ListPromoCodeTemplatesForBrandsAvail) {
                this._ListPromoCodeTemplatesForBrandsAvail = new ListPromoCodeTemplatesForBrandsAvailCtl_1.ListPromoCodeTemplatesForBrandsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPromoCodeTemplatesForBrandsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPromoCodeTemplatesForLevelsAvail", {
        get: function () {
            if (!this._ListPromoCodeTemplatesForLevelsAvail) {
                this._ListPromoCodeTemplatesForLevelsAvail = new ListPromoCodeTemplatesForLevelsAvailCtl_1.ListPromoCodeTemplatesForLevelsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPromoCodeTemplatesForLevelsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListCmsGameSetsAvail", {
        get: function () {
            if (!this._ListCmsGameSetsAvail) {
                this._ListCmsGameSetsAvail = new ListCmsGameSetsAvailCtl_1.ListCmsGameSetsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListCmsGameSetsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListCmsGameSetGamesAvail", {
        get: function () {
            if (!this._ListCmsGameSetGamesAvail) {
                this._ListCmsGameSetGamesAvail = new ListCmsGameSetGamesAvailCtl_1.ListCmsGameSetGamesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListCmsGameSetGamesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBrandsAvail", {
        get: function () {
            if (!this._ListBrandsAvail) {
                this._ListBrandsAvail = new ListBrandsAvailCtl_1.ListBrandsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBrandsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAdminsAvail", {
        get: function () {
            if (!this._ListAdminsAvail) {
                this._ListAdminsAvail = new ListAdminsAvailCtl_1.ListAdminsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAdminsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListGwsGameProvidersAvail", {
        get: function () {
            if (!this._ListGwsGameProvidersAvail) {
                this._ListGwsGameProvidersAvail = new ListGwsGameProvidersAvailCtl_1.ListGwsGameProvidersAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListGwsGameProvidersAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListGwsGameProviderGamesAvail", {
        get: function () {
            if (!this._ListGwsGameProviderGamesAvail) {
                this._ListGwsGameProviderGamesAvail = new ListGwsGameProviderGamesAvailCtl_1.ListGwsGameProviderGamesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListGwsGameProviderGamesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAffilatesAvail", {
        get: function () {
            if (!this._ListAffilatesAvail) {
                this._ListAffilatesAvail = new ListAffilatesAvailCtl_1.ListAffilatesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAffilatesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppCurrencyAvail", {
        get: function () {
            if (!this._ListAppCurrencyAvail) {
                this._ListAppCurrencyAvail = new ListAppCurrencyAvailCtl_1.ListAppCurrencyAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppCurrencyAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppCountryAvail", {
        get: function () {
            if (!this._ListAppCountryAvail) {
                this._ListAppCountryAvail = new ListAppCountryAvailCtl_1.ListAppCountryAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppCountryAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppLanguageAvail", {
        get: function () {
            if (!this._ListAppLanguageAvail) {
                this._ListAppLanguageAvail = new ListAppLanguageAvailCtl_1.ListAppLanguageAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppLanguageAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppCssClassesAvail", {
        get: function () {
            if (!this._ListAppCssClassesAvail) {
                this._ListAppCssClassesAvail = new ListAppCssClassesAvailCtl_1.ListAppCssClassesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppCssClassesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppCssClassesTypesAvail", {
        get: function () {
            if (!this._ListAppCssClassesTypesAvail) {
                this._ListAppCssClassesTypesAvail = new ListAppCssClassesTypesAvailCtl_1.ListAppCssClassesTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppCssClassesTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppPayoutsAvail", {
        get: function () {
            if (!this._ListAppPayoutAvail) {
                this._ListAppPayoutAvail = new ListAppPayoutAvailCtl_1.ListAppPayoutAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppPayoutAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppUserPlayerTagTypesAvail", {
        get: function () {
            if (!this._ListAppUserPlayerTagTypesAvail) {
                this._ListAppUserPlayerTagTypesAvail = new ListAppUserPlayerTagTypesAvailCtl_1.ListAppUserPlayerTagTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAppUserPlayerTagTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAppUserPlayerTagsAvail", {
        get: function () {
            if (!this._listAppUserPlayerTagsAvail) {
                this._listAppUserPlayerTagsAvail = new ListAppUserPlayerTagsAvailCtl_1.ListAppUserPlayerTagsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._listAppUserPlayerTagsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListGwsEMailActions", {
        get: function () {
            if (!this._ListGwsEMailActions) {
                this._ListGwsEMailActions = new ListEmailActionsAvailCtl_1.ListEmailActionsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListGwsEMailActions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListGwsSmsActions", {
        get: function () {
            if (!this._ListGwsSmsActions) {
                this._ListGwsSmsActions = new ListSmsActionsAvailCtl_1.ListSmsActionsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListGwsSmsActions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusEventTypesAvail", {
        get: function () {
            if (!this._ListBonusEventTypesAvail) {
                this._ListBonusEventTypesAvail = new ListBonusEventTypesAvailCtl_1.ListBonusEventTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusEventTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListEventBindingBonusesList", {
        get: function () {
            if (!this._EventBindingBonusesList) {
                this._EventBindingBonusesList = new EventBindingBonusesListCtl_1.EventBindingBonusesListCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._EventBindingBonusesList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusTemplateTypesAvail", {
        get: function () {
            if (!this._ListBonusTemplateTypesAvail) {
                this._ListBonusTemplateTypesAvail = new ListBonusTemplateTypesAvailCtl_1.ListBonusTemplateTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusTemplateTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusLevelsAvail", {
        get: function () {
            if (!this._ListBonusLevelsAvail) {
                this._ListBonusLevelsAvail = new ListBonusLevelsAvailCtl_1.ListBonusLevelsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusLevelsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusCancelTypesAvail", {
        get: function () {
            if (!this._ListBonusCancelTypesAvail) {
                this._ListBonusCancelTypesAvail = new ListBonusCancelTypesAvailCtl_1.ListBonusCancelTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusCancelTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusDebitTypesAvail", {
        get: function () {
            if (!this._ListBonusDebitTypesAvail) {
                this._ListBonusDebitTypesAvail = new ListBonusDebitTypesAvailCtl_1.ListBonusDebitTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusDebitTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusWithdrawalBehaviorTypesAvail", {
        get: function () {
            if (!this._ListBonusWithdrawalBehaviorTypesAvail) {
                this._ListBonusWithdrawalBehaviorTypesAvail = new ListBonusWithdrawalBehaviorTypesAvailCtl_1.ListBonusWithdrawalBehaviorTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusWithdrawalBehaviorTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusActivationTypesAvail", {
        get: function () {
            if (!this._ListBonusActivationTypesAvail) {
                this._ListBonusActivationTypesAvail = new ListBonusActivationTypesAvailCtl_1.ListBonusActivationTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusActivationTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusJackpotTransferTypesAvail", {
        get: function () {
            if (!this._ListBonusJackpotTransferTypesAvail) {
                this._ListBonusJackpotTransferTypesAvail = new ListBonusJackpotTransferTypesAvailCtl_1.ListBonusJackpotTransferTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusJackpotTransferTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusJackpotsAvail", {
        get: function () {
            if (!this._ListBonusJackpotsAvail) {
                this._ListBonusJackpotsAvail = new ListBonusJackpotsAvailCtl_1.ListBonusJackpotsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusJackpotsAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusPermissionTypesAvail", {
        get: function () {
            if (!this._ListBonusPermissionTypesAvail) {
                this._ListBonusPermissionTypesAvail = new ListBonusPermissionTypesAvailCtl_1.ListBonusPermissionTypesAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusPermissionTypesAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusTemplatesAvailForEventHandlers", {
        get: function () {
            if (!this._ListBonusesAvailForEventHandlers) {
                this._ListBonusesAvailForEventHandlers = new ListBonusTemplatesAvailForEventHandlersCtl_1.ListBonusTemplatesAvailForEventHandlersCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusesAvailForEventHandlers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusTemplatesAvailForPromoCodes", {
        get: function () {
            if (!this._ListBonusesAvailForPromoCodes) {
                this._ListBonusesAvailForPromoCodes = new ListBonusTemplatesAvailForPromoCodesCtl_1.ListBonusTemplatesAvailForPromoCodesCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusesAvailForPromoCodes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusesAvailForDepositType", {
        get: function () {
            if (!this._ListBonusesAvailForDepositType) {
                this._ListBonusesAvailForDepositType = new ListBonusTemplatesAvailForDepositTypeCtl_1.ListBonusTemplatesAvailForDepositTypeCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusesAvailForDepositType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListBonusesAvailForPlayer", {
        get: function () {
            if (!this._ListBonusesAvailForPlayer) {
                this._ListBonusesAvailForPlayer = new ListBonusTemplatesAvailForPlayers_1.ListBonusTemplatesAvailForPlayersCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListBonusesAvailForPlayer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListPlayerLevelsByCurrencyIdAndBrandIdAvail", {
        get: function () {
            if (!this._ListPlayerLevelsByCurrencyIdAndBrandIdAvail) {
                this._ListPlayerLevelsByCurrencyIdAndBrandIdAvail = new ListPlayerLevelsByBrandIdAvailCtl_1.ListPlayerLevelsByBrandIdAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListPlayerLevelsByCurrencyIdAndBrandIdAvail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LIST, "ListAdminsPermissionsAvail", {
        get: function () {
            if (!this._ListAdminsPermissionsAvail) {
                this._ListAdminsPermissionsAvail = new ListAdminsPermissionsAvailCtl_1.ListAdminsPermissionsAvailCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._ListAdminsPermissionsAvail;
        },
        enumerable: true,
        configurable: true
    });
    return LIST;
}());
exports.LIST = LIST;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/coreList.ts
// module id = 2057
// module chunks = 0